module.exports = __webpack_public_path__ + "assets/img/company5.1a3eda29.png";